<template>
  <div class="busWrap">
    <commonHead :wareName="wareName" :log='newLog'></commonHead>
    <wareList :wareList='wareList' :wareId='wareId' :height='height' @getWareId='switchWareId'></wareList>
    <div class='container-right'>
      <div class='showView' :style="`height:${height-20}px;width:${width-240}px`">
        <component :is='showWrap' :importPath='importPath' :wareId='wareId' :wareType='wareType' :height='height' :width='width'></component>
      </div>
    </div>
  </div>
</template>

<script>
import commonHead from './commonHead';
import wareList from './wareList';
import setTemp from '../airCondItioner/setTemp';
import airConfig from '../airCondItioner/airConfig';
import oilWareInfo from '../oilSituation/oilWareInfo';
import multifunctional from '../multifunctional/multifunctional'
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
    log:'',
    nav:'',
    oldWareId:''
  },
  components:{
    commonHead,
    wareList,
    setTemp,
    airConfig,
    oilWareInfo,
    multifunctional
  },
  data(){
    return{
      wareName:'',
      wareList:[],
      wareId:0,
      showWrap:null,
      newLog:'',
      wareType:'',
      importPath:'dynamic'
    }
  },
  created(){
    this.getWareList();
  },
  watch: {
    log(newV, oldV) {
      this.showWrap=newV;
      if(newV=='oilWareInfo'){
        this.newLog='油情信息'
      }else if(newV=='setTemp'){
        this.newLog='空调信息'
      }else if(newV=='airConfig'){
        this.newLog='配置信息'
      }else if(newV=='multifunctional'){
        this.newLog='设备状态'
      }
    }
  },
  methods:{
    getWareList(){
      let type=0
      if(this.nav=='oil'){
        type=1
      }else{
        type=0
      }
      this.getMode()
      axios.get('/system/house/getHouseSelect',{params:{type:type}}).then(data=>{
        if(data.code==200){
          this.wareList=data.data;
          data.data.forEach((item,index)=>{
            if(this.oldWareId){
              if(item.wareId==this.oldWareId){
                this.wareId=item.wareId;
                this.wareName=item.wareName;
                this.wareType=item.wareType;
              }
            }else{
              this.wareId=data.data[0].wareId
              this.wareName=data.data[0].wareName;
              this.wareType=data.data[0].wareType
            }
          })
        }else{
          this.$message({
            message:data.msg,
            type:"error",
            duration:1000
          })
        }
      })
    },
    switchWareId(res){
      this.wareId=res;
      this.wareList.forEach(item=>{
        if(item.wareId==res){
          this.wareName=item.wareName;
          this.wareType=item.wareType;
        }
      })
    },
    getMode(){
      this.showWrap=this.log
      if(this.log=='oilWareInfo'){
        this.newLog='油情信息'
      }else if(this.log=='setTemp'){
        this.newLog='空调信息'
      }else if(this.log=='airConfig'){
        this.newLog='配置信息'
      }else if(this.log=='multifunctional'){
        this.newLog='设备状态'
      }
    }
  }
}
</script>

<style>
  .busWrap{
    height: 100%;
    width: 100%;
    position: relative;
  }
</style>